// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { connectAuthEmulator, getAuth } from "firebase/auth";
import { connectDatabaseEmulator, getDatabase } from "firebase/database";
import { connectFirestoreEmulator, getFirestore } from "firebase/firestore";
import { connectStorageEmulator, getStorage } from "firebase/storage";
import { getAnalytics } from "firebase/analytics";
import { connectFunctionsEmulator, getFunctions } from "firebase/functions";
// Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCaoCDF9lhu6-xY2mw1RabcvQPMqAsr0Qc",
  authDomain: "oussama-maatallah.firebaseapp.com",
  databaseURL: "https://oussama-maatallah-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "oussama-maatallah",
  storageBucket: "oussama-maatallah.appspot.com",
  messagingSenderId: "635763589672",
  appId: "1:635763589672:web:111a7a125c2b2dc46b2b1d",
  measurementId: "G-LCNHQCW27K"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const firestore = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);
const database = getDatabase(app);
const analytics = getAnalytics(app);
const functions = getFunctions(app, "europe-west9");

// use emulator if it's a dev environment
if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
  console.log("using firebase emulator");
  connectFirestoreEmulator(firestore, "localhost", 8080);
  connectAuthEmulator(auth, "http://127.0.0.1:9099");
  connectStorageEmulator(storage, "localhost", 9199);
  connectDatabaseEmulator(database, "127.0.0.1", 9000);
  connectFunctionsEmulator(functions, "127.0.0.1", 5001);
}

export { app, auth, database, firestore, storage, analytics, functions };

